import React, { useState } from 'react';
import { TextField, Box, List, ListItem, ListItemText, ListItemAvatar, Avatar, Paper, useMediaQuery } from '@mui/material';
import { getSearchKdramas } from '../components/API';
import { useNavigate } from 'react-router-dom';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/system';

function SearchBar() {
    const [searchTerm, setSearchTerm] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // Check if it's mobile screen

    const handleSearchChange = async (e) => {
        const value = e.target.value;
        setSearchTerm(value);

        if (value.trim()) {
            try {
                const data = await getSearchKdramas(value);
                setSearchResults(data.results.filter(kdrama => kdrama.original_language === 'ko'));
            } catch (error) {
                console.error('Erreur lors de la recherche de K-dramas:', error);
            }
        } else {
            setSearchResults([]);
        }
    };

    const handleSearchResultClick = (id) => {
        navigate(`/kdrama/${id}`);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                width: isMobile ? '100%' : '350px', // Responsive width
                flexDirection: 'column',
                alignItems: 'center',
                marginBottom: '1rem',
            }}
        >
            <TextField
                label="Rechercher un K-drama"
                placeholder="Tapez pour rechercher"
                variant="outlined"
                value={searchTerm}
                onChange={handleSearchChange}
                sx={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '500px', // Responsive width
                    marginBottom: '1rem',
                    borderRadius: '5px',
                    fontFamily: "SUSE, sans-serif",
                    backgroundColor: '#f9f9f9',
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            borderColor: '#ddd',
                        },
                        '&:hover fieldset': {
                            borderColor: '#ccc',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#888',
                        },
                    },
                }}
                InputProps={{
                    sx: { paddingRight: 0 },
                    endAdornment: (
                        <SearchIcon sx={{ marginRight: '10px', color: '#888' }} />
                    )
                }}
            />
            {searchResults.length > 0 && (
                <Paper
                    elevation={3}
                    sx={{
                        width: '100%',
                        maxWidth: isMobile ? '100%' : '500px', // Responsive width
                        mt: 1,
                        borderRadius: '8px',
                        overflow: 'hidden',
                    }}
                >
                    <List sx={{ bgcolor: 'background.paper' }}>
                        {searchResults.map(kdrama => (
                            <ListItem
                                key={kdrama.id}
                                sx={{
                                    fontFamily: "SUSE, sans-serif",
                                    cursor: 'pointer',
                                    transition: 'background-color 0.3s',
                                    '&:hover': {
                                        backgroundColor: '#f5f5f5',
                                    },
                                    '&:not(:last-child)': {
                                        borderBottom: '1px solid #eee',
                                    },
                                    padding: '10px 16px',
                                }}
                                onClick={() => handleSearchResultClick(kdrama.id)}
                            >
                                <ListItemAvatar>
                                    <Avatar
                                        alt={kdrama.name}
                                        src={`https://image.tmdb.org/t/p/w92${kdrama.poster_path}`}
                                        sx={{ width: 64, height: 64, borderRadius: '8px' }}
                                    />
                                </ListItemAvatar>
                                <ListItemText
                                    primary={kdrama.name}
                                    primaryTypographyProps={{
                                        marginLeft: '10px',
                                        fontWeight: 'bold',
                                        fontSize: '1.1rem',
                                        fontFamily: "SUSE, sans-serif",
                                    }}
                                />
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            )}
        </Box>
    );
}

export default SearchBar;
